import { httpClient } from "@coworker/http-client";

async function deleteTeam(teamId: string) {
  const result = await httpClient.core.delete(`/teams/${teamId}`, {
    body: {},
  });

  return result;
}

export default deleteTeam;
